import { useMutation, useQuery } from "@tanstack/react-query";
import {
  AccountSettings,
  deleteAccount,
  sendOtp,
  updateCredentials,
  clearSession,
  successStories,
  updateAuthentication,
  updateNotifications,
  updatePersonalinfo,
  verifyOtp,
  SessionSettings,
  privacyUpdate,
} from "api/settings";
import AlertNotification from "components/CustomWidgets/alertNotification";
import { useAuth } from "context/AuthContext";
import { storeToken } from "utils/storage";

export const useAccountSettings = (options = {}) => {
  return useQuery({
    queryKey: ["account_settings"],
    queryFn: AccountSettings,
    ...options,
  });
};

export const useSessionSettings = ({ device_id }, options = {}) => {
  return useQuery({
    queryKey: ["SessionSettings", { device_id }],
    queryFn: SessionSettings,
    ...options,
  });
};

export const useUpdateCredentials = (options = {}) => {
  return useMutation({
    mutationFn: updateCredentials,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useupdateAuthentication = (options = {}) => {
  return useMutation({
    mutationFn: updateAuthentication,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useclearSession = (options = {}) => {
  return useMutation({
    mutationFn: clearSession,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useupdateNotifications = (options = {}) => {
  return useMutation({
    mutationFn: updateNotifications,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usesuccessStories = (options = {}) => {
  return useMutation({
    mutationFn: successStories,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useUpdatePersonalInfo = (options = {}) => {
  return useMutation({
    mutationFn: updatePersonalinfo,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useSendOtp = (options = {}) => {
  return useMutation({
    mutationFn: sendOtp,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useVerifyOtp = (options = {}) => {
  return useMutation({
    mutationFn: verifyOtp,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useDeleteAccount = (options = {}) => {
  const { logout } = useAuth();
  return useMutation({
    mutationFn: deleteAccount,
    onSuccess: (data, variables, context) => {
      logout();
      storeToken("gopremiummodal", "false");
      AlertNotification(
        "success",
        data.message || "Account deactivated successfully",
      );
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usePrivacyUpdate = (options = {}) => {
  return useMutation({
    mutationFn: privacyUpdate,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};
